export enum ApprobationExplanationDialogFormLabelsEnum {
  TITLE = 'Dispute Approval Explanation',
  DESCRIPTION = 'Please explain the reason for approval',
  REASON_CODE = 'Decision Reason Code',
  REASON_EXPLANATION = 'Reason for Approval',
  SUBMIT = 'Approve',
  CANCEL = 'Cancel',
}
